import React, { Component, Fragment } from "react";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { formatCurrency } from "../../adukku_utils/formatCurrency";

class DownloadFiles extends Component {
  constructor(props) {
    super(props);
    this.state = { ...props, expand: false, isEditProductClicked: false };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps !== this.state) {
      this.setState({ ...nextProps });
    }
  }

  UNSAFE_componentWillMount() {
    this.props.getSets(this.props.product.id);
  }

  onExpandToggle = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ expand: !this.state.expand });
  };

  getExpandJSX = (expandFlag) => {
    return (
      <span>
        {expandFlag && <i className="icon-collapse" aria-hidden="true"></i>}
        {!expandFlag && <i className="icon-expand" aria-hidden="true"></i>}
      </span>
    );
  };

  getOrderedProductSets = (order) => {
    if (order && order.status == "paid") {
      let t = [];
      let sets = order && order.order_details && order.order_details.sets;
      let product_sets = this.state.product_sets;
      if (sets && Object.keys(sets).includes("all")) {
        return product_sets.map((product_set, i) => {
          let counts =
            (product_set &&
              product_set.counts &&
              product_set.counts[this.state.main_dlname]) ||
            [];
          const count = (counts || []).find(
            (f) => f.setno == product_set.setno
          ) || {
            main_occurence_count: 0
          };
          let productSetRecords = [];
          for (let index = 1; index < count.main_occurence_count; index++) {
            productSetRecords.push(<li>{"Record No " + index}</li>);
          }
          return (
            <li
              className="no-textcolor"
              onClick={() => {
                this.setState({
                  [`p_set_${product_set.setno}`]: !(
                    this.state[`p_set_${product_set.setno}`] || false
                  )
                });
              }}
            >
              {this.getExpandJSX(
                this.state[`p_set_${product_set.setno}`] || false
              )}
              {product_set && " " + product_set.desc}
              {this.state[`p_set_${product_set.setno}`] && (
                <ul>{productSetRecords}</ul>
              )}
            </li>
          );
        });
      } else if (sets && Object.keys(sets).length > 0) {
        return Object.keys(sets).map((setno) => {
          let product_set = (product_sets || []).find(
            (set) => set.setno == setno
          );
          let counts =
            (product_set &&
              product_set.counts &&
              product_set.counts[this.state.main_dlname]) ||
            [];
          const count = (counts || []).find((f) => f.setno == setno) || {
            main_occurence_count: 0
          };
          let productSetRecords = [];
          let seq_nos = Object.keys(sets[setno] || {});
          // Object.keys(sets[setno]).map((seq_no) => {});
          for (let index = 0; index < seq_nos.length; index++) {
            productSetRecords.push(
              <li>{"Record No " + (parseInt(seq_nos[index]) + 1)}</li>
            );
          }
          // if (sets[setno] && Object.keys(sets[setno]).includes("all")) {
          //   for (let index = 1; index < count.main_occurence_count; index++) {
          //     productSetRecords.push(<li>{"Record No " + index}</li>);
          //   }
          // } else if (Object.keys(sets[setno]).length > 0) {
          //   let seq_nos = Object.keys(sets[setno] || {});
          //   // Object.keys(sets[setno]).map((seq_no) => {});
          //   for (let index = 1; index < seq_nos.length; index++) {
          //     productSetRecords.push(<li>{"Record No " + seq_nos[index]}</li>);
          //   }
          // }
          return (
            <li
              className="no-textcolor"
              onClick={() => {
                this.setState({
                  [`p_set_${product_set.setno}`]: !(
                    this.state[`p_set_${product_set.setno}`] || false
                  )
                });
              }}
            >
              {this.getExpandJSX(
                this.state[`p_set_${product_set.setno}`] || false
              )}
              {product_set && " " + product_set.desc}
              {this.state[`p_set_${product_set.setno}`] && (
                <ul>{productSetRecords}</ul>
              )}
            </li>
          );
        });
      }
    }
  };

  printDocument = (orderId) => {
    const input = document.getElementById("divToPrint2");
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg");
      const pdf = new jsPDF();
      var width = pdf.internal.pageSize.getWidth();
      var height = pdf.internal.pageSize.getHeight();
      pdf.addImage(imgData, "JPEG", 0, 0, width, height);
      // pdf.output('dataurlnewwindow');
      pdf.save(`${orderId}.pdf`);
    });
  };

  getOrderInvoice = (order) => {
    let user = {};
    let amount =
      order.paypal_capture.purchase_units[0].table.payments.table.captures[0]
        .table.amount.table.value;
    console.log("paypal_capture.amount=> ", amount);
    // const convenienceCharges = formatCurrency(
    //   order.total_amount - order.total_files_amount,
    //   100,
    //   "USD"
    // );
    return (
      <Modal
        dialogClassName="modal-90w"
        centered="true"
        show={this.state.isEditProductClicked}
        onHide={(e) => {
          this.setState({
            currentOrder: null,
            isEditProductClicked: false
          });
        }}
      >
        <Form className="override_form" onSubmit={this.handleEditProduct}>
          <Modal.Header closeButton>
            <Modal.Title>Invoice</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div id="divToPrint" style={{ justifyContent: "center" }}>
              <div
                id="divToPrint2"
                // className="mt4"

                style={{
                  backgroundColor: "#fff",
                  width: "60%",
                  padding: "50px",
                  minHeight: "297mm",
                  marginLeft: "auto",
                  marginRight: "auto",
                  border: "1px solid",
                  boxShadow: `0 10px 25px rgba(0, 0, 0, 0.5)`
                }}
              >
                <table style={{ width: "100%" }}>
                  <tr>
                    <td>
                      <img
                        src={`${order.host_url}/Composz-logo-black-trans.png`}
                        style={{ height: "50px" }}
                      />
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <span
                        style={{
                          fontSize: "34px",
                          color: "#0070c0",
                          fontWeight: "34px"
                        }}
                      >
                        <b>INVOICE</b>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>COMPOSZ LLC,</td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Invoice #: INVFIL00000{order.id}
                    </td>
                  </tr>
                  <tr>
                    <td>#121 HAUT BRION AVENUE</td>{" "}
                    {
                      //  <td style={{ textAlign: "right" }}>Invoice Date: {order.created_at}</td>
                      // Bala Edit - Commented above and added below line with Date Function
                    }
                    <td style={{ textAlign: "right" }}>
                      Invoice Date:{" "}
                      {
                        new Date(order.created_at)
                          .toLocaleString()
                          .split(",")[0]
                      }
                    </td>
                  </tr>
                  <tr>
                    <td>NEWARK, DE-19702.</td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Invoice Amount: {formatCurrency(amount, 1, "USD")}
                      {/* {(order.total_amount / 100).toFixed(2)} */}
                    </td>
                  </tr>
                  <tr>
                    <td></td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Status:{" "}
                      <span style={{ color: "#92d050", fontSize: "20px" }}>
                        PAID
                      </span>
                    </td>
                  </tr>
                </table>
                <span>
                  <b>BILLED TO</b>
                </span>
                <p>
                  <span>{order.full_name || "Not Provided"}</span>
                  <br />
                  <span>{order.email}</span>
                  <br />
                  <span>{order.address || "Not Provided"}</span>
                </p>
                <br />
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr
                      style={{
                        borderBottom: "0.5px solid black",
                        borderTop: "0.5px solid black"
                      }}
                    >
                      <th>Description</th>
                      <th>Price</th>
                      <th>Quantity</th>
                      <th>Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>&nbsp;Digital Files - (.jpeg)</td>
                      <td>
                        {formatCurrency(order.price_first_page, 100, "USD")}
                        {/* ${(order.price_first_page / 100).toFixed(2)} */}
                      </td>
                      <td>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{order.num_files}
                      </td>
                      <td>
                        {formatCurrency(order.total_files_amount, 100, "USD")}
                        {/* ${(order.total_files_amount / 100).toFixed(2)} */}
                      </td>
                    </tr>
                    {order.prtype !== "NORMAL" ? (
                      <tr>
                        <td>&nbsp;Audio Files - {order.prtype} - (.html)</td>
                        <td>
                          {formatCurrency(4, 1, "USD")}/record
                          {/* ${(order.price_first_page / 100).toFixed(2)} */}
                        </td>
                        <td>Upto&nbsp;{order.num_files}&nbsp; files</td>
                        <td>
                          {formatCurrency(
                            4 * (order.num_files / this.state.product.numpages),
                            1,
                            "INR"
                          )}
                          {/* ${(order.total_files_amount / 100).toFixed(2)} */}
                        </td>
                      </tr>
                    ) : null}
                    <br></br>
                    <tr
                      style={{
                        borderBottom: "0.5px solid black",
                        borderTop: "0.5px solid black"
                      }}
                    ></tr>
                  </tbody>
                </table>
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th>PAYMENT DETAILS</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Paypal Transaction ID | {order.paypal_capture_id}</td>
                      {order.prtype !== "NORMAL" ? (
                        <td style={{ textAlign: "right" }}>
                          Item (s) Subtotal:{" "}
                          {formatCurrency(
                            order.total_files_amount / 100 +
                              4 *
                                (order.num_files / this.state.product.numpages),
                            1,
                            "USD"
                          )}
                          {/* ${(order.total_files_amount / 100).toFixed(2)} */}
                        </td>
                      ) : (
                        <td style={{ textAlign: "right" }}>
                          Item (s) Subtotal:{" "}
                          {formatCurrency(order.total_files_amount, 100, "USD")}
                          {/* ${(order.total_files_amount / 100).toFixed(2)} */}
                        </td>
                      )}
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "right" }}>
                        Convenience charges:{" "}
                        {formatCurrency(
                          order.total_amount - order.total_files_amount,
                          100,
                          "USD"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "right" }}>
                        Tax to be collected:{" "}
                        {formatCurrency(order.pg_fixed_fee, 100, "USD")}
                        {/* {(order.pg_fixed_fee / 100).toFixed(2)} */}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      {order.prtype !== "NORMAL" ? (
                        <td style={{ textAlign: "right" }}>
                          <b>
                            GRAND TOTAL :{" "}
                            {formatCurrency(
                              order.total_files_amount / 100 +
                                4 *
                                  (order.num_files /
                                    this.state.product.numpages) +
                                (order.total_amount -
                                  order.total_files_amount) /
                                  100,
                              1,
                              "USD"
                            )}
                            {/* ${(order.total_amount / 100).toFixed(2)} */}
                          </b>
                        </td>
                      ) : (
                        <td style={{ textAlign: "right" }}>
                          <b>
                            GRAND TOTAL :{" "}
                            {formatCurrency(order.total_amount, 100, "USD")}
                            {/* ${(order.total_amount / 100).toFixed(2)} */}
                          </b>
                        </td>
                      )}
                    </tr>
                  </tbody>
                </table>

                <p>
                  {" "}
                  To download the digital files, login to https://composz.com
                </p>
                <p>Thanks for your purchase</p>
                <p>-- team Composz</p>
                <br></br>
                <br></br>
                <br></br>
                {order.prtype !== "NORMAL" ? (
                  <p
                    style={{
                      borderBottom: "0.5px solid black",
                      borderTop: "0.5px solid black"
                    }}
                  >
                    <b>Note: </b>If no Audio is recorded, no Audio files (.html)
                    will be generated; User will still be charged due to user's
                    Product choice of Voice Options & provision of Voice
                    recording infrastructure made available to the user. It is
                    user's responsibility to record Audio or choose NO-VOICE for
                    Product.
                  </p>
                ) : null}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="button"
              onClick={() => {
                this.printDocument(`INVFIL00000${order.id}`);
              }}
            >
              Download
            </Button>
            <Button
              onClick={(e) => {
                this.setState({
                  isEditProductClicked: false
                });
              }}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  };

  getccavenueOrderInvoice = (order) => {
    let user = {};
    console.log(order);

    // const convenienceCharges = formatCurrency(
    //   order.total_amount - order.total_files_amount,
    //   100,
    //   "USD"
    // );
    return (
      <Modal
        dialogClassName="modal-90w"
        centered="true"
        show={this.state.isEditProductClicked}
        onHide={(e) => {
          this.setState({
            currentOrder: null,
            isEditProductClicked: false
          });
        }}
      >
        <Form className="override_form" onSubmit={this.handleEditProduct}>
          <Modal.Header closeButton>
            <Modal.Title>Invoice</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div id="divToPrint" style={{ justifyContent: "center" }}>
              <div
                id="divToPrint2"
                // className="mt4"

                style={{
                  backgroundColor: "#fff",
                  width: "60%",
                  padding: "50px",
                  minHeight: "297mm",
                  marginLeft: "auto",
                  marginRight: "auto",
                  border: "1px solid",
                  boxShadow: `0 10px 25px rgba(0, 0, 0, 0.5)`
                }}
              >
                <table style={{ width: "100%" }}>
                  <tr>
                    <td>
                      <img
                        src={`${order.host_url}/Composz-logo-black-trans.png`}
                        style={{ height: "50px" }}
                      />
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <span
                        style={{
                          fontSize: "34px",
                          color: "#0070c0",
                          fontWeight: "34px"
                        }}
                      >
                        <b>INVOICE</b>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>LIFE COLORS,</td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Invoice #: INVFIL00000{order.id}
                    </td>
                  </tr>
                  <tr>
                    <td>#9, 4th Cross, Kothanur Main Road,</td>{" "}
                    {
                      //  <td style={{ textAlign: "right" }}>Invoice Date: {order.created_at}</td>
                      // Bala Edit - Commented above and added below line with Date Function
                    }
                    <td style={{ textAlign: "right" }}>
                      Invoice Date:{" "}
                      {
                        new Date(order.created_at)
                          .toLocaleString()
                          .split(",")[0]
                      }
                    </td>
                  </tr>
                  <tr>
                    <td>Bangalore 560 062.</td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Invoice Amount:{" "}
                      {formatCurrency(order.ccavenue_capture.amount, 1, "INR")}
                      {/* {(order.total_amount / 100).toFixed(2)} */}
                    </td>
                  </tr>
                  <tr>
                    <td>GSTIN: 29AUTPB5544P1ZS; GST SAC Code: 998434</td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Status:{" "}
                      <span style={{ color: "#92d050", fontSize: "20px" }}>
                        PAID
                      </span>
                    </td>
                  </tr>
                </table>
                <span>
                  <b>BILLED TO</b>
                </span>
                <p>
                  <span>{order.ccavenue_capture.billing_name}</span>
                  <br />
                  <span>{order.ccavenue_capture.billing_address}</span>
                  <br />
                  <span>
                    {order.ccavenue_capture.billing_city},{" "}
                    {order.ccavenue_capture.billing_state} -{" "}
                    {order.ccavenue_capture.billing_zip}
                  </span>
                  <br />
                  <span>
                    {order.email}, {order.ccavenue_capture.billing_tel}
                  </span>
                  <br />
                </p>
                <br />
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr
                      style={{
                        borderBottom: "0.5px solid black",
                        borderTop: "0.5px solid black"
                      }}
                    >
                      <th>Description</th>
                      <th>Price</th>
                      <th>Quantity</th>
                      <th>Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>Digital Files - (.jpeg)</td>
                      <td>
                        {formatCurrency(order.price_first_page, 1, "INR")}
                        {/* ${(order.price_first_page / 100).toFixed(2)} */}
                      </td>
                      <td>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{order.num_files}
                      </td>
                      <td>
                        {formatCurrency(order.total_files_amount, 1, "INR")}
                        {/* ${(order.total_files_amount / 100).toFixed(2)} */}
                      </td>
                    </tr>
                    {order.prtype !== "NORMAL" ? (
                      <tr>
                        <td>Audio Files - {order.prtype} - (.html)</td>
                        <td>
                          {formatCurrency(
                            parseInt(
                              order.prtype.split("-")[1].split("SEC")[0]
                            ) == 15
                              ? 127
                              : 200,
                            1,
                            "INR"
                          )}
                          /record
                          {/* ${(order.price_first_page / 100).toFixed(2)} */}
                        </td>
                        <td>Upto&nbsp;{order.num_files}&nbsp;files</td>
                        <td>
                          {formatCurrency(
                            (parseInt(
                              order.prtype.split("-")[1].split("SEC")[0]
                            ) == 15
                              ? 127
                              : 200) *
                              (order.num_files / this.state.product.numpages),
                            1,
                            "INR"
                          )}
                          {/* ${(order.total_files_amount / 100).toFixed(2)} */}
                        </td>
                      </tr>
                    ) : null}
                    <br></br>
                    <tr
                      style={{
                        borderBottom: "0.5px solid black",
                        borderTop: "0.5px solid black"
                      }}
                    ></tr>
                  </tbody>
                </table>
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th>PAYMENT DETAILS</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        CCAvenue Tracking ID:{" "}
                        {order.ccavenue_capture.tracking_id}
                      </td>
                      {order.prtype !== "NORMAL" ? (
                        <td style={{ textAlign: "right" }}>
                          Item (s) Subtotal:{" "}
                          {formatCurrency(
                            order.total_files_amount +
                              (parseInt(
                                order.prtype.split("-")[1].split("SEC")[0]
                              ) == 15
                                ? 127
                                : 200) *
                                (order.num_files / this.state.product.numpages),
                            1,
                            "INR"
                          )}
                          {/* ${(order.total_files_amount / 100).toFixed(2)} */}
                        </td>
                      ) : (
                        <td style={{ textAlign: "right" }}>
                          Item (s) Subtotal:{" "}
                          {formatCurrency(order.total_files_amount, 1, "INR")}
                          {/* ${(order.total_files_amount / 100).toFixed(2)} */}
                        </td>
                      )}
                    </tr>
                    <tr>
                      <td>
                        Payment Mode: {order.ccavenue_capture.payment_mode}{" "}
                        {"-"} {order.ccavenue_capture.card_name}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        Convenience charges:{" "}
                        {formatCurrency(
                          order.num_files * order.pg_transaction_fee,
                          1,
                          "INR"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Bank Ref No: {order.ccavenue_capture.bank_ref_no}</td>
                      {order.prtype !== "NORMAL" ? (
                        <td style={{ textAlign: "right" }}>
                          GST 18%:{" "}
                          {formatCurrency(
                            (order.num_files * 75.0 +
                              order.num_files * 10.0 +
                              (parseInt(
                                order.prtype.split("-")[1].split("SEC")[0]
                              ) == 15
                                ? 127
                                : 200) *
                                (order.num_files /
                                  this.state.product.numpages)) *
                              0.18,
                            1,
                            "INR"
                          )}
                          {/* {(order.pg_fixed_fee / 100).toFixed(2)} */}
                        </td>
                      ) : (
                        <td style={{ textAlign: "right" }}>
                          GST 18%:{" "}
                          {formatCurrency(
                            (order.num_files * 75.0 + order.num_files * 10.0) *
                              0.18,
                            1,
                            "INR"
                          )}
                          {/* {(order.pg_fixed_fee / 100).toFixed(2)} */}
                        </td>
                      )}
                    </tr>
                    <tr>
                      <td></td>
                      {order.prtype !== "NORMAL" ? (
                        <td style={{ textAlign: "right" }}>
                          <b>
                            GRAND TOTAL :{" "}
                            {formatCurrency(
                              Math.round(
                                order.num_files * 75.0 +
                                  order.num_files * 10.0 +
                                  (parseInt(
                                    order.prtype.split("-")[1].split("SEC")[0]
                                  ) == 15
                                    ? 127
                                    : 200) *
                                    (order.num_files /
                                      this.state.product.numpages) +
                                  (order.num_files * 75.0 +
                                    order.num_files * 10.0 +
                                    (parseInt(
                                      order.prtype.split("-")[1].split("SEC")[0]
                                    ) == 15
                                      ? 127
                                      : 200) *
                                      (order.num_files /
                                        this.state.product.numpages)) *
                                    0.18
                              ),
                              1,
                              "INR"
                            )}
                            {/* ${(order.total_amount / 100).toFixed(2)} */}
                          </b>
                        </td>
                      ) : (
                        <td style={{ textAlign: "right" }}>
                          <b>
                            GRAND TOTAL:{" "}
                            {formatCurrency(order.total_amount, 1, "INR")}
                            {/* ${(order.total_amount / 100).toFixed(2)} */}
                          </b>
                        </td>
                      )}
                    </tr>
                  </tbody>
                </table>

                <p>
                  {" "}
                  To download the digital files, login to https://composz.com
                </p>
                <p> Thanks for your purchase</p>
                <p> --team Composz</p>
                <br></br>
                <br></br>
                <br></br>
                {order.prtype !== "NORMAL" ? (
                  <p
                    style={{
                      borderBottom: "0.5px solid black",
                      borderTop: "0.5px solid black"
                    }}
                  >
                    <b>Note: </b>If no Audio is recorded, no Audio files (.html)
                    will be generated; User will still be charged due to user's
                    Product choice of Voice Options & provision of Voice
                    recording infrastructure made available to the user. It is
                    user's responsibility to record Audio or choose NO-VOICE for
                    Product.
                  </p>
                ) : null}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="button"
              onClick={() => {
                this.printDocument(`INVFIL00000${order.id}`);
              }}
            >
              Download
            </Button>
            <Button
              onClick={(e) => {
                this.setState({
                  isEditProductClicked: false
                });
              }}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  };

  getrazorpayOrderInvoice = (order) => {
    let user = {};

    // const convenienceCharges = formatCurrency(
    //   order.total_amount - order.total_files_amount,
    //   100,
    //   "USD"
    // );
    return (
      <Modal
        dialogClassName="modal-90w"
        centered="true"
        show={this.state.isEditProductClicked}
        onHide={(e) => {
          this.setState({
            currentOrder: null,
            isEditProductClicked: false
          });
        }}
      >
        <Form className="override_form" onSubmit={this.handleEditProduct}>
          <Modal.Header closeButton>
            <Modal.Title>Invoice</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div id="divToPrint" style={{ justifyContent: "center" }}>
              <div
                id="divToPrint2"
                // className="mt4"

                style={{
                  backgroundColor: "#fff",
                  width: "60%",
                  padding: "50px",
                  minHeight: "297mm",
                  marginLeft: "auto",
                  marginRight: "auto",
                  border: "1px solid",
                  boxShadow: `0 10px 25px rgba(0, 0, 0, 0.5)`
                }}
              >
                <table style={{ width: "100%" }}>
                  <tr>
                    <td>
                      <img
                        src={`${order.host_url}/Composz-logo-black-trans.png`}
                        style={{ height: "50px" }}
                      />
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <span
                        style={{
                          fontSize: "34px",
                          color: "#0070c0",
                          fontWeight: "34px"
                        }}
                      >
                        <b>INVOICE</b>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>LIFE COLORS,</td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Invoice #: INVFIL00000{order.id}
                    </td>
                  </tr>
                  <tr>
                    <td>#9, 4th Cross, Kothanur Main Road,</td>{" "}
                    {
                      //  <td style={{ textAlign: "right" }}>Invoice Date: {order.created_at}</td>
                      // Bala Edit - Commented above and added below line with Date Function
                    }
                    <td style={{ textAlign: "right" }}>
                      Invoice Date:{" "}
                      {
                        new Date(order.created_at)
                          .toLocaleString()
                          .split(",")[0]
                      }
                    </td>
                  </tr>
                  <tr>
                    <td>Bangalore 560 062.</td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Invoice Amount:{" "}
                      {formatCurrency(
                        order.razorpay_capture.amount,
                        100,
                        "INR"
                      )}
                      {/* {(order.total_amount / 100).toFixed(2)} */}
                    </td>
                  </tr>
                  <tr>
                    <td>GSTIN: 29AUTPB5544P1ZS; GST SAC Code: 998434</td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Status:{" "}
                      <span style={{ color: "#92d050", fontSize: "20px" }}>
                        PAID
                      </span>
                    </td>
                  </tr>
                </table>
                <span>
                  <b>BILLED TO</b>
                </span>
                <p>
                  <br></br>
                  <span>{order.user_name}</span>
                  <br></br>
                  <span>{order.razorpay_capture.email}</span>
                  <br></br>
                  <span>{order.razorpay_capture.contact}</span>
                  <br />
                </p>
                <br />
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr
                      style={{
                        borderBottom: "0.5px solid black",
                        borderTop: "0.5px solid black"
                      }}
                    >
                      <th>Description</th>
                      <th>Price</th>
                      <th>Quantity</th>
                      <th>Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>Digital Files - (.jpeg)</td>
                      <td>
                        {formatCurrency(order.price_first_page, 1, "INR")}
                        {/* ${(order.price_first_page / 100).toFixed(2)} */}
                      </td>
                      <td>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{order.num_files}
                      </td>
                      <td>
                        {formatCurrency(order.total_files_amount, 1, "INR")}
                        {/* ${(order.total_files_amount / 100).toFixed(2)} */}
                      </td>
                    </tr>

                    {order.prtype !== "NORMAL" ? (
                      <tr>
                        <td>Audio Files - {order.prtype} - (.html)</td>
                        <td>
                          {formatCurrency(
                            parseInt(
                              order.prtype.split("-")[1].split("SEC")[0]
                            ) == 15
                              ? 127
                              : 200,
                            1,
                            "INR"
                          )}
                          /record
                          {/* ${(order.price_first_page / 100).toFixed(2)} */}
                        </td>
                        <td>Upto&nbsp;{order.num_files}&nbsp;files</td>
                        <td>
                          {formatCurrency(
                            (parseInt(
                              order.prtype.split("-")[1].split("SEC")[0]
                            ) == 15
                              ? 127
                              : 200) *
                              (order.num_files / this.state.product.numpages),
                            1,
                            "INR"
                          )}
                          {/* ${(order.total_files_amount / 100).toFixed(2)} */}
                        </td>
                      </tr>
                    ) : null}
                    <br></br>
                    <tr
                      style={{
                        borderBottom: "0.5px solid black",
                        borderTop: "0.5px solid black"
                      }}
                    ></tr>
                  </tbody>
                </table>
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th>PAYMENT DETAILS</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Razorpay Payment ID: {order.razorpay_capture.id}</td>
                      {order.prtype !== "NORMAL" ? (
                        <td style={{ textAlign: "right" }}>
                          Item (s) Subtotal:{" "}
                          {formatCurrency(
                            order.total_files_amount +
                              (parseInt(
                                order.prtype.split("-")[1].split("SEC")[0]
                              ) == 15
                                ? 127
                                : 200) *
                                (order.num_files / this.state.product.numpages),
                            1,
                            "INR"
                          )}
                          {/* ${(order.total_files_amount / 100).toFixed(2)} */}
                        </td>
                      ) : (
                        <td style={{ textAlign: "right" }}>
                          Item (s) Subtotal:{" "}
                          {formatCurrency(order.total_files_amount, 1, "INR")}
                          {/* ${(order.total_files_amount / 100).toFixed(2)} */}
                        </td>
                      )}
                    </tr>
                    <tr>
                      <td>
                        Payment Mode: {order.razorpay_capture.method}
                        {order.razorpay_capture.method == "netbanking"
                          ? "-" + order.razorpay_capture.bank
                          : ""}
                        {order.razorpay_capture.method == "card"
                          ? "-" +
                            order.razorpay_capture.card.network +
                            "-xxxx-" +
                            order.razorpay_capture.card.last4
                          : ""}
                        {order.razorpay_capture.method == "upi"
                          ? "-" +
                            order.razorpay_capture.vpa +
                            "-Ph:" +
                            order.razorpay_capture.acquirer_data.rrn
                          : ""}
                        {order.razorpay_capture.method == "wallet"
                          ? "-" + order.razorpay_capture.wallet
                          : ""}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        Convenience charges:{" "}
                        {formatCurrency(
                          order.num_files * order.pg_transaction_fee,
                          1,
                          "INR"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Transaction ID:
                        {order.razorpay_capture.method == "netbanking"
                          ? order.razorpay_capture.acquirer_data
                              .bank_transaction_id
                          : ""}
                        {order.razorpay_capture.method == "card"
                          ? order.razorpay_capture.acquirer_data.auth_code
                          : ""}
                        {order.razorpay_capture.method == "upi"
                          ? order.razorpay_capture.acquirer_data
                              .upi_transaction_id
                          : ""}
                        {order.razorpay_capture.method == "wallet"
                          ? " N/A"
                          : ""}
                      </td>
                      {order.prtype !== "NORMAL" ? (
                        <td style={{ textAlign: "right" }}>
                          GST 18%:{" "}
                          {formatCurrency(
                            (order.num_files * 75.0 +
                              order.num_files * 10.0 +
                              (parseInt(
                                order.prtype.split("-")[1].split("SEC")[0]
                              ) == 15
                                ? 127
                                : 200) *
                                (order.num_files /
                                  this.state.product.numpages)) *
                              0.18,
                            1,
                            "INR"
                          )}
                          {/* {(order.pg_fixed_fee / 100).toFixed(2)} */}
                        </td>
                      ) : (
                        <td style={{ textAlign: "right" }}>
                          GST 18%:{" "}
                          {formatCurrency(
                            (order.num_files * 75.0 + order.num_files * 10.0) *
                              0.18,
                            1,
                            "INR"
                          )}
                          {/* {(order.pg_fixed_fee / 100).toFixed(2)} */}
                        </td>
                      )}
                    </tr>
                    <tr>
                      <td></td>
                      {order.prtype !== "NORMAL" ? (
                        <td style={{ textAlign: "right" }}>
                          <b>
                            GRAND TOTAL :{" "}
                            {formatCurrency(
                              Math.round(
                                order.num_files * 75.0 +
                                  order.num_files * 10.0 +
                                  (parseInt(
                                    order.prtype.split("-")[1].split("SEC")[0]
                                  ) == 15
                                    ? 127
                                    : 200) *
                                    (order.num_files /
                                      this.state.product.numpages) +
                                  (order.num_files * 75.0 +
                                    order.num_files * 10.0 +
                                    (parseInt(
                                      order.prtype.split("-")[1].split("SEC")[0]
                                    ) == 15
                                      ? 127
                                      : 200) *
                                      (order.num_files /
                                        this.state.product.numpages)) *
                                    0.18
                              ),
                              1,
                              "INR"
                            )}
                            {/* ${(order.total_amount / 100).toFixed(2)} */}
                          </b>
                        </td>
                      ) : (
                        <td style={{ textAlign: "right" }}>
                          <b>
                            GRAND TOTAL:{" "}
                            {formatCurrency(order.total_amount, 1, "INR")}
                            {/* ${(order.total_amount / 100).toFixed(2)} */}
                          </b>
                        </td>
                      )}
                    </tr>
                  </tbody>
                </table>

                <p>
                  {" "}
                  To download the digital files, login to https://composz.com
                </p>
                <p> Thanks for your purchase</p>
                <p> --team Composz</p>
                <br></br>
                <br></br>
                <br></br>
                {order.prtype !== "NORMAL" ? (
                  <p
                    style={{
                      borderBottom: "0.5px solid black",
                      borderTop: "0.5px solid black"
                    }}
                  >
                    <b>Note: </b>If no Audio is recorded, no Audio files (.html)
                    will be generated; User will still be charged due to user's
                    Product choice of Voice Options & provision of Voice
                    recording infrastructure made available to the user. It is
                    user's responsibility to record Audio or choose NO-VOICE for
                    Product.
                  </p>
                ) : null}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="button"
              onClick={() => {
                this.printDocument(`INVFIL00000${order.id}`);
              }}
            >
              Download
            </Button>
            <Button
              onClick={(e) => {
                this.setState({
                  isEditProductClicked: false
                });
              }}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  };

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  countryCode = this.getCookie("countryCode");

  render() {
    const product_sets = this.props.product_sets;
    const product = this.props.product;
    const expand = this.state.expand;
    const paidOrders = this.state.paidOrders || [];
    const type = this.state.type;
    const treeName = this.state.treeName;
    if (product_sets == null) {
      return null;
    }
    return (
      <li>
        <a className="no-textcolor" onClick={this.onExpandToggle}>
          {this.getExpandJSX(expand)} {treeName}
        </a>
        {expand && (
          <React.Fragment>
            <ul className="tree">
              {paidOrders.map((order, i) => {
                return (
                  <li>
                    <span
                      className="no-textcolor"
                      onClick={() => {
                        this.setState({
                          [`order_${order.id}`]: !(
                            this.state[`order_${order.id}`] || false
                          )
                        });
                      }}
                    >
                      {this.getExpandJSX(
                        this.state[`order_${order.id}`] || false
                      )}
                      {" Order ID " +
                        order.id +
                        " " +
                        `${new Date(order.created_at).toLocaleString()} `}

                      <a
                        target="_blank"
                        href={`${window.origin}/uploads/products/${
                          product.id
                        }/orders/order-${parseInt(
                          new Date(order.created_at).getTime() / 1000
                        )}-${order.id}.zip`}
                      >
                        Download
                      </a>
                      {window.sub_id === 0 ? (
                        <Fragment>
                          {" "}
                          |{" "}
                          <a
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              this.setState({
                                currentOrder: order,
                                isEditProductClicked:
                                  !this.state.isEditProductClicked
                              });
                            }}
                          >
                            Invoice
                          </a>
                        </Fragment>
                      ) : (
                        ""
                      )}
                    </span>
                    {this.state[`order_${order.id}`] && (
                      <ul>{this.getOrderedProductSets(order)}</ul>
                    )}
                  </li>
                );
              })}
            </ul>
            {/* {this.state.isEditProductClicked && (this.countryCode!=="IN"?this.getOrderInvoice(this.state.currentOrder):this.getccavenueOrderInvoice(this.state.currentOrder))} */}
            {this.state.isEditProductClicked &&
              (this.countryCode !== "IN"
                ? this.getOrderInvoice(this.state.currentOrder)
                : this.getrazorpayOrderInvoice(this.state.currentOrder))}
          </React.Fragment>
        )}
      </li>
    );
  }
}

export default DownloadFiles;
